/**
 * 根据日期粒度echarts grid的right值
 * @param right - 初始right值
 * @param granularity - 日期粒度
 * @return 根据日期粒度处理后的right值
 */
export const getTrendsChartGridRightByGranularity = (right: number | string, granularity: IGranularity): number => {
  const rightNum = Number.parseFloat(right as unknown as string);

  if (Number.isNaN(rightNum)) {
    return 0;
  }

  if (granularity === 'monthly') {
    return rightNum - 10;
  }

  return rightNum;
};

/**
 * x轴高亮显示刻度
 * @param option echarts的option配置项
 * @param config 其他配置
 * @param config.lineStyle x轴刻度线的样式
 * @param config.formatter x轴刻度的格式化函数
 * @returns echarts的option配置项
 */
export const xAxisHighLight = (
  option: IEChartOption,
  config?: {
    lineStyle?: any;
    formatter?: any;
  },
) => {
  const { lineStyle, formatter } = config || {};

  return {
    ...option,
    tooltip: {
      ...option?.tooltip,
      axisPointer: {
        z: 0,
        label: {
          show: true,
          fontWeight: 700,
          fontSize: 12,
          color: '#262832',
          backgroundColor: '#ffffff',
          formatter: (params: any) => {
            return formatter ? formatter(params) : params?.value;
          },
        },
        lineStyle: lineStyle || {
          type: 'solid',
          width: 1,
          color: '#cccccc',
        },
      },
    },
  };
};

/**
 * 构建内边框圆点 symbol（色环向内收，不撑大 symbolSize）
 * @param ringColor - 外圈颜色
 * @param size - 圆点尺寸（默认 6）
 * @param borderWidth - 边框宽度（默认 2）
 * @param innerColor - 内圈填充色（默认 '#FFFFFF'）
 * @returns ECharts image:// SVG 字符串
 */
export const buildInnerBorderCircleSymbol = (
  ringColor: string,
  size = 6,
  borderWidth = 2,
  innerColor = '#FFFFFF',
): string => {
  const radius = size / 2;
  const innerRadius = radius - borderWidth;
  const svg = [
    `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">`,
    `<circle cx="${radius}" cy="${radius}" r="${radius}" fill="${ringColor}"/>`,
    `<circle cx="${radius}" cy="${radius}" r="${innerRadius}" fill="${innerColor}"/>`,
    '</svg>',
  ].join('');
  return `image://data:image/svg+xml,${encodeURIComponent(svg)}`;
};
